module.exports = __webpack_public_path__ + "img/one_5.d03d1d64.png";